// InlineLoginOTP.jsx
import React, { useEffect, useRef, useState } from "react";
import axios from "axios";

export default function InlineLoginOTP({ email, t, onVerified }) {
  const tr = (k, fb) => (typeof t === "function" ? t(k) : fb);

  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const otpRefs = useRef([...Array(6)].map(() => React.createRef()));
  const [msg, setMsg] = useState("");
  const [verifying, setVerifying] = useState(false);
  const [sending, setSending] = useState(false);

  // OPTIONAL: auto-send OTP when the component mounts.
  // If your /api/login already triggers the email, you can comment this out.
  // useEffect(() => {
  //   let cancelled = false;
  //   console.log('/send-otp-Validate-Email #')
  //   const send = async () => {
  //     try {
  //       setSending(true);
  //       await axios.post("https://projet-collect-v1-production.up.railway.app/send-otp", { email });
  //       if (!cancelled) setMsg(tr("otpSent", "A 6-digit code was sent to ") + email);
  //     } catch (e) {
  //       if (!cancelled) setMsg(tr("errorSendingOTP", "Error sending OTP"));
  //     } finally {
  //       if (!cancelled) setSending(false);
  //     }
  //   };
  //   send();
  //   return () => { cancelled = true; };
  // }, [email]);

  const onOtpChange = (v, idx) => {
    if (/^\d?$/.test(v)) {
      const next = [...otp];
      next[idx] = v;
      setOtp(next);
      if (v && idx < 5) otpRefs.current[idx + 1].current?.focus();
    }
  };

  const onOtpPaste = (e) => {
    const digits = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, 6);
    if (digits.length === 6) {
      setOtp(digits.split(""));
      otpRefs.current[5].current?.focus();
    }
    e.preventDefault();
  };

  const verify = async (e) => {
    e.preventDefault();
    setMsg("");
    const code = otp.join("");
    if (code.length !== 6) return setMsg(tr("otpIncomplete", "Enter the 6-digit code"));
    try {
      setVerifying(true);
      // IMPORTANT: point this to your login-OTP verify endpoint.
      // It should return the SAME payload as your email+password login success
      // { success, userId, userName, ProfilePicture, csrfToken, token }
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE}/verify-otp-login`,
        { email, otp: code },
        { withCredentials: true }
      );

      if (res?.data?.success) {
         console.log("OTP verified, data:", res.data);
        onVerified?.(res.data);
      } else {
        setMsg(tr("otpError", "Invalid code. Try again."));
      }
    } catch (err) {
      setMsg(tr("verifyOtpError", "Error verifying code"));
      console.error(err);
    } finally {
      setVerifying(false);
    }
  };

  return (
    <form className="auth__card" onSubmit={verify}>
      <p style={{ marginBottom: 8 }}>{tr("enterOtpSubtitle", "We sent a code to")} <b>{email}</b></p>

      <div className="otp__grid" onPaste={onOtpPaste}>
        {otp.map((d, i) => (
          <input
            key={i}
            ref={otpRefs.current[i]}
            className="otp__input"
            inputMode="numeric"
            pattern="[0-9]*"
            maxLength={1}
            value={d}
            onChange={(e) => onOtpChange(e.target.value, i)}
            aria-label={tr("otpDigit", "OTP digit")}
            onKeyDown={(e) => {
              if (e.key === "Backspace" && !otp[i] && i > 0) {
                otpRefs.current[i - 1].current?.focus();
              }
            }}
            autoComplete="one-time-code"
          />
        ))}
      </div>

      <button type="submit" className="btn-primary w-full" disabled={verifying || sending}>
        {verifying ? tr("verifying", "Verifying…") : tr("verifyOtpButton", "Verify code")}
      </button>

      {msg ? <p className="auth__message">{msg}</p> : null}
    </form>
  );
}
